import {
  Button,
  FormControl,
  Grid,
  InputLabel,
  Modal,
  Select,
  Typography,
  makeStyles,
  TextField,
} from "@material-ui/core";
import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../context";
import { orderServices, productsServices } from "../services";
import SuccessIcon from "../icons/success";

const useStyles = makeStyles((theme) => ({
  modalStyle: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "90%", // Ajusta el ancho del modal para pantallas pequeñas
    maxWidth: 400, // Ancho máximo del modal
    backgroundColor: "white",
    border: "2px solid #000",
    padding: theme.spacing(2, 4, 3),
    borderRadius: "15px",
    outline: "none",
    [theme.breakpoints.down("sm")]: {
      width: "95%", // Ajusta el ancho del modal para dispositivos medianos
    },
    [theme.breakpoints.down("xs")]: {
      width: "70%", // Ajusta el ancho del modal para dispositivos pequeños
      //top: "0",     // Ajusta la posición superior para dispositivos pequeños
      // transform: "translate(0%, 0%)", // Ajusta la transformación para dispositivos pequeños
      borderRadius: "0", // Sin bordes redondeados en dispositivos pequeños
    },
  },
  button: {
    backgroundColor: "#FFF",
    fontSize: "1rem",
    height: "auto",
    width: "200px",
    borderRadius: 16,
    textTransform: "none",
    color: theme.palette.secondary.main,
    border: `1px solid ${theme.palette.secondary.main}`,
    boxSizing: "border-box",
    "&:hover": {
      backgroundColor: theme.palette.secondary.main,
      color: "#FFF",
    },
    margin: "auto", // Centra el botón horizontalmente
    display: "block",
    marginTop: "10px",
    [theme.breakpoints.down("sm")]: {
      width: "130px", // Ajusta el ancho del botón para dispositivos pequeños
    },
    [theme.breakpoints.down("xs")]: {
      width: "100px", // Ajusta el ancho del botón para dispositivos extra pequeños
      fontSize: "0.9rem", // Reduce el tamaño de la fuente para dispositivos extra pequeños
    },
  },
}));

export function EditStatusModal({
  open,
  onClose,
  assigmentId,
  assignment,
  orderStatuses,
  handleUpdateOrderStatus,
  loading,
}) {
  console.log("assignment: ", assignment);
  const classes = useStyles();
  const [status, setStatus] = useState(assignment.status);
  const { authState, signOut } = useContext(AuthContext);
  const [openMessage, setOpenMessage] = useState(false);
  const [showOrderCode, setShowOrderCode] = useState(
    assignment.status === "66182a037b4df03548c40403" || assignment.status === 3
  );
  const [showInDeliveryComments, setShowInDeliveryComments] = useState(
    assignment.status === "66182a037b4df03548c40403" || assignment.status === 3
  );
  const [orderCode, setOrderCode] = useState(assignment.orderCode);
  const [inDeliveryComments, setInDeliveryComments] = useState(
    assignment.inDeliveryComments || ""
  );
  const [errorOrderCode, setErrorOrderCode] = useState({
    msg: "",
    error: false,
  });

  const updateOrderStatus = async () => {
    if (errorOrderCode.error) return;
    if (showOrderCode && !orderCode) {
      setErrorOrderCode({
        error: true,
        msg: "El codigo de orden es requerido",
      });
      return;
    }

    const data = {
      token: authState.token,
      orderId: assigmentId,
      statusId: status,
      orderCode: showOrderCode ? orderCode : assignment.orderCode,
      inDeliveryComments: showInDeliveryComments
        ? inDeliveryComments
        : assignment.inDeliveryComments || "",
    };
    onClose();
    handleUpdateOrderStatus(data);
  };

  const handleChangeOrderCode = (e) => {
    const value = e.target.value;
    const pattern = /^[a-zA-Z0-9]*$/;
    setOrderCode(e.target.value.toUpperCase());
    if (!value) {
      setErrorOrderCode({
        error: true,
        msg: "El codigo de orden es requerido",
      });
      return;
    }

    if (!pattern.test(value)) {
      setErrorOrderCode({
        error: true,
        msg: "Solo se aceptan valores alfanuméricos",
      });
      return;
    }
    setErrorOrderCode({
      error: false,
      msg: "",
    });
  };
  return (
    <>
      <Modal
        open={open}
        onClose={onClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <div className={classes.modalStyle}>
          <FormControl fullWidth>
            <InputLabel htmlFor="orders-status-select" shrink>
              Selecciona un estado
            </InputLabel>
            <Select
              native
              value={status}
              onChange={(e) => {
                const newStatus = e.target.value;
                setStatus(newStatus);
                const showCodeOrderEntry =
                  e.target.value === "66182a037b4df03548c40403";
                if (showCodeOrderEntry === showOrderCode) return;
                setShowOrderCode(showCodeOrderEntry);
                setShowInDeliveryComments(showCodeOrderEntry);
              }}
              inputProps={{
                name: "orders-status",
                id: "orders-status-select",
              }}
            >
              <option aria-label="None" value="" />
              {orderStatuses.map((status) => (
                <option key={status._id} value={status._id}>
                  {status.name}
                </option>
              ))}
            </Select>
          </FormControl>
          {showOrderCode && (
            <TextField
              label="Código de orden"
              name="codeOrder"
              size="small"
              value={orderCode}
              onChange={handleChangeOrderCode}
              {...{
                error: errorOrderCode.error,
                helperText: errorOrderCode.msg,
              }}
              InputLabelProps={{
                shrink: true,
              }}
              variant="outlined"
              fullWidth
              margin="normal"
            />
          )}
          {showInDeliveryComments && (
            <TextField
              multiline
              label="Comentarios de entrega"
              name="InDeliveryComments"
              size="small"
              value={inDeliveryComments}
              onChange={(e) => setInDeliveryComments(e.target.value)}
              variant="outlined"
              fullWidth
              margin="normal"
            />
          )}
          <Button
            disabled={loading}
            className={classes.button}
            onClick={updateOrderStatus}
          >
            Editar estatus
          </Button>
        </div>
      </Modal>
      <Modal open={Boolean(openMessage)} onClose={() => setOpenMessage(false)}>
        <div className={classes.modalStyle}>
          <Grid
            container
            display="flex"
            direction="column"
            alignItems="center"
            justifty="center"
            style={{ padding: "2rem 1rem", gap: "15px" }}
          >
            <Grid item>
              <SuccessIcon />
            </Grid>
            <Grid item style={{ margin: "auto 0" }}>
              <Typography
                style={{ fontWeight: "bold", fontSize: "1rem" }}
                align="center"
                color="primary"
              >
                {openMessage}
              </Typography>
            </Grid>
            <Grid item>
              <Button
                fullWidth
                variant="contained"
                style={{
                  backgroundColor: "#2196C0",
                  textTransform: "none",
                  color: "white",
                }}
                onClick={() => {
                  setOpenMessage(false);
                }}
              >
                Aceptar
              </Button>
            </Grid>
          </Grid>
        </div>
      </Modal>
    </>
  );
}
